import React from "react";
import Select from "react-select";
import {sweetalert} from "../../App";
import {isEmptyObject} from "jquery";
import {buildRow, getReactSelectAriaLabel, getReactSelectAriaLabelMultiselect, getSelectLabels, getlabelsFromIDs} from "../../util/FormatUtil";
import {isBlank, isOnlyWhitespace, isValidEmail} from "../../util/ValidationUtil";
import PhoneInput from 'react-phone-number-input'
import UsersAPI from "../../network/UsersAPI";
import SystemAPI from "../../network/SystemAPI";

interface PermsState{
    selectedUser: {
        UUID?
        FirstName?
        LastName?
        DisplayName?
        Email?
        SelectedPerms
        SelectedFacilities
        Status: string
        Disable: boolean
        AuthFacilityGroup,
        PhoneNumber
        FacilityIDs
    },
    permGroups: { label, value }[],
    facilityGroups: { label, value }[]
    districts?: { label, value }[]
    selectedSchoolDistrict?: { label, value } | null
    idFrontUrl?: string
    idImagesLoading?: boolean
    idActionLoading?: boolean
}

interface PermsProps{
    selectedUser
    facilityGroups
    permissionGroups
    facilities
    facilitiesWithInfo
    onSubmit
    onIDStatusChanged?: () => void
}

export class UserManagementModal extends React.Component<PermsProps, PermsState>{
    public static readonly ID = "userManagement";

    constructor(props) {
        super(props);
        this.state = {
            selectedUser: {
                UUID: -1,
                DisplayName: '',
                FirstName:'',
                LastName:'',
                Email:'',
                SelectedPerms:[],
                SelectedFacilities: [],
                Status: 'Enabled',
                Disable: false,
                AuthFacilityGroup:null,
                PhoneNumber: null,
                FacilityIDs: null
            },
            facilityGroups:[],
            permGroups:[],
            districts:[],
            selectedSchoolDistrict: undefined,
        } as PermsState;
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount(): void {
        // Load school districts so school-user accounts can scope the school list by district
        SystemAPI.getAllSchoolDistricts().then(data => {
            this.setState({ districts: data });
        });
        // $(`#${UserManagementModal.ID}`).on('shown.bs.modal', function() {
        //     $(document).off('focusin.modal');
        // });
    }

    componentWillUnmount() {
        if (this.state.idFrontUrl) URL.revokeObjectURL(this.state.idFrontUrl);
    }

    componentWillReceiveProps(nextProps: Readonly<PermsProps>, _nextContext: any) {
        // Reset ID verification state when user changes
        if (nextProps.selectedUser?.UUID !== this.props.selectedUser?.UUID) {
            if (this.state.idFrontUrl) URL.revokeObjectURL(this.state.idFrontUrl);
            this.setState({ idFrontUrl: undefined, idImagesLoading: false, idActionLoading: false, selectedSchoolDistrict: undefined });
        }

        if(nextProps.facilityGroups){
            this.setState({facilityGroups: nextProps.facilityGroups})
        }

        if(nextProps.permissionGroups){
            this.setState({permGroups: nextProps.permissionGroups})
        }

        if (!isEmptyObject(nextProps.selectedUser)) {
            let user = nextProps.selectedUser;

            if (user.UUID && user.UUID !== -1) {
                let selectedFacilities = user.FacilityIDs && user.FacilityIDs.length > 0 ? this.props.facilities.filter(f =>
                    JSON.parse(user.FacilityIDs).includes(f.value) // FacilityIDs comes in as "[378]" not [378]
                ) : [];
                this.setState({
                    selectedUser: {
                        DisplayName: user.DisplayName,
                        FirstName: user.FirstName,
                        LastName: user.LastName,
                        Email: user.Email,
                        SelectedPerms: this.state.permGroups.filter(f =>
                            user.Permissions.find(selected=>selected.id === f.value)
                        ),
                        SelectedFacilities: selectedFacilities,
                        Status: user.Status,
                        Disable: user.Status === 'DEACTIVATE',
                        UUID: user.UUID,
                        AuthFacilityGroup: this.state.facilityGroups.find(a =>
                            user &&
                            user.AuthFacilityGroup === a.value ? a : null
                        ),
                        PhoneNumber:user.PhoneNumber ? user.PhoneNumber : null,
                        FacilityIDs : user.FacilityIDs ?  user.FacilityIDs : null
                    },
                    // Reset to "not chosen" so the District filter shows the value derived
                    // from the user's schools (computed in getEffectiveSchoolDistrict). The
                    // admin can still override or clear it.
                    selectedSchoolDistrict: undefined
                })
            } else {
                this.setState({
                    selectedUser: {
                        DisplayName: "",
                        FirstName: "",
                        LastName: "",
                        Email: "",
                        SelectedPerms: [],
                        SelectedFacilities: [],
                        Status: "Enabled",
                        Disable: false,
                        AuthFacilityGroup: null,
                        UUID: -1,  // -1 means no user, create one
                        PhoneNumber:null,
                        FacilityIDs: null
                    }
                });
            }
        }
    }

    public static display(){
        window["$"]("#" + UserManagementModal.ID).modal({
            backdrop: 'static', // prevent outside click
            keyboard: false // prevent esc close
        })
    }

    getRoleDesc(){
        let fac = (
          <div style={{ fontSize: "small" }}>
            <p>Facility permission groups only have access to users and facilities to which they are assigned.</p>
            <dl className={"row"}>
              <dt className={"col-md-3"}>OSDH-IMM Admin</dt>
              <dd className={"col-md-9"}>Access to Vaccine Exemptions, Public Users, Audit Logs, Facility, User, Communication, File, Banner, Password Requirements</dd>
            </dl>
            <dl className={"row"}>
              <dt className={"col-md-3"}>OSDH-IMM Read-Only</dt>
              <dd className={"col-md-9"}>Read-Only access to Vaccine Exemptions, Public Users</dd>
            </dl>
            <dl className={"row"}>
              <dt className={"col-md-3"}>OSDH-IMM School User</dt>
              <dd className={"col-md-9"}>Read-Only access to Vaccine Exemptions scoped to assigned school</dd>
            </dl>
          </div>
        );
        // let global = (<div style={{fontSize: "small"}}>
        //     <p>Global permission groups have access to all patients and facilities, regardless of their assigned facility group. They have permission to download a CSV export from Samples page with Patient Identifiers, and can access Audit Logs.</p>
        //     <dl className={"row"}>
        //     <dt className={"col-md-3"}>OraPath Global Admin</dt>
        //         <dd className={"col-md-9"}>On OraPath Portals only, user can: Edit and read access to Testing Check-in, Submission Form, Rapid Test Management, Schedule Management and Stats, Send Alert, Samples, Facility Management, and User Management.</dd>
        //     </dl>
        // </div>);
        let isGlob = this.state.permGroups.find(f => f.value === 2); //used to be Okta Global Lab group

        return (
            <div className={"col-md-12"}>
                <h5>Permission Group Descriptions</h5>
                <div className={"col-md-12"}>
                    {fac}
                    {isGlob ? global : null}
                </div>
                <hr />
            </div>
        )
    }

    hasSchoolUserPerm(){
        return this.state.selectedUser.SelectedPerms?.some(p => p.value === 17);
    }

    handleChange(event) {
        this.setState((prevState) => ({
            selectedUser:{
                ...prevState.selectedUser,
                Disable: event.target.checked
            }
        }))
    }

    getUserAccountStatusInput(){
        let userAccountIsActive = this.state.selectedUser.Status === 'Enabled' &&
            this.state.selectedUser.UUID !== -1;

        let showAccountStatusAndCheckbox = (
            <div className={"col-sm-8 p-0 m-0 input-group"}>
                <input type={"search"} className={"form-control"}
                    readOnly={true} id={"Status"} value={this.state.selectedUser.Status} />
                <div className={"input-group-append"}>
                    <span className={"input-group-text disable-check-label"}>
                        Disable Account
                        <input className={"input-group-addon disable-check-input"}
                            type={"checkbox"}
                            onChange={this.handleChange}
                            checked={this.state.selectedUser.Disable}
                            readOnly={this.state.selectedUser.UUID !== -1}
                        />
                    </span>
                </div>
            </div>
        );

        let showAccountStatus = (
            <div className={"col-sm-8 p-0 m-0"}>
                <input type={"search"} className={"form-control"}
                    readOnly={true} id={"Status"} value={this.state.selectedUser.Status} />
            </div>
        );

        return (
            <div className={"form-group row"}>
                <label htmlFor={"Status"} className={"col-sm-4 col-form-label"}>
                    Account Status
                </label>
                { userAccountIsActive ?
                    showAccountStatusAndCheckbox :
                    showAccountStatus
                }
            </div>
        )
    }

    facilityLabel(f, allFacilities){
        let dupes = allFacilities.filter(other => other.FacilityName === f.FacilityName).length > 1;
        return dupes && f.FacilityCity ? `${f.FacilityName} (${f.FacilityCity})` : f.FacilityName;
    }

    // Derives the School District option from a user's assigned schools so the District
    // filter can be pre-populated when viewing an existing record. Returns the matching
    // district only when every assigned school shares a single district; otherwise null
    // (ambiguous/none) so the school list stays unfiltered.
    deriveSchoolDistrict(selectedFacilities){
        if(!selectedFacilities || selectedFacilities.length === 0) return null;
        let facs = this.props.facilitiesWithInfo || [];
        let districtIDs = Array.from(new Set(
            selectedFacilities
                .map(sf => facs.find(f => f.ID === sf.value)?.SchoolDistrictID)
                .filter(id => id !== null && id !== undefined)
        ));
        if(districtIDs.length !== 1) return null;
        return (this.state.districts || []).find(d => d.value === districtIDs[0]) || null;
    }

    // The School District filter value, computed at render rather than stored, so it's
    // always correct regardless of when the async districts list loads (no race):
    //   selectedSchoolDistrict === undefined -> not chosen; use the district derived from the user's schools
    //   an option                            -> the user's explicit selection
    //   null                                 -> explicitly cleared (show all schools)
    getEffectiveSchoolDistrict(){
        if(this.state.selectedSchoolDistrict !== undefined){
            return this.state.selectedSchoolDistrict;
        }
        return this.deriveSchoolDistrict(this.state.selectedUser.SelectedFacilities);
    }

    getSchoolOrFacilityOptions(){
        if(!this.hasSchoolUserPerm()){
            return this.getFacilitesIncludedInSelectedFacilityGroup();
        }
        const district = this.getEffectiveSchoolDistrict();
        return this.props.facilitiesWithInfo
            .filter(f => f.FacilityType === 'School')
            .filter(f => !district || f.SchoolDistrictID === district.value)
            .map(f => ({label: this.facilityLabel(f, this.props.facilitiesWithInfo), value: f.ID}));
    }

    getFacilitesIncludedInSelectedFacilityGroup(){
        let options = [];

        // If no facility group is selected, show all facilities
        let hasFacilityGroup = this.state.selectedUser && this.state.selectedUser.AuthFacilityGroup && !isEmptyObject(this.state.selectedUser.AuthFacilityGroup);
        let filtered = hasFacilityGroup
            ? this.props.facilitiesWithInfo.filter(f => f.FacilityGroup === this.state.selectedUser.AuthFacilityGroup.label)
            : this.props.facilitiesWithInfo;

        filtered.map(f => {
            options.push({label: this.facilityLabel(f, filtered), value: f.ID})
        })

        return options;
    }


    async loadIDImages() {
        const user = this.props.selectedUser;
        if (!user?.IDFrontPath) return;

        this.setState({ idImagesLoading: true });
        try {
            const frontUrl = await UsersAPI.viewIDImage(user.IDFrontPath);
            this.setState({
                idFrontUrl: frontUrl,
                idImagesLoading: false,
            });
        } catch {
            this.setState({ idImagesLoading: false });
            sweetalert.fire({ icon: "error", text: "Unable to load ID image." });
        }
    }

    async handleApproveID() {
        const uuid = this.props.selectedUser?.UUID;
        if (!uuid || this.state.idActionLoading) return;

        const confirm = await sweetalert.fire({
            title: "Approve ID?",
            text: "This will approve the user's ID verification and grant them access to the portal.",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Approve",
        });
        if (!confirm.isConfirmed) return;

        this.setState({ idActionLoading: true });
        try {
            const response = await UsersAPI.approveIDVerification(uuid);
            if (response?.success) {
                await sweetalert.fire({ icon: "success", text: "ID verification approved. The user has been notified via email." });
                this.props.onIDStatusChanged?.();
            } else {
                sweetalert.fire({ icon: "error", text: response?.reason || "Unable to approve ID verification." });
            }
        } finally {
            this.setState({ idActionLoading: false });
        }
    }

    async handleDenyID() {
        const uuid = this.props.selectedUser?.UUID;
        if (!uuid || this.state.idActionLoading) return;

        const confirm = await sweetalert.fire({
            title: "Deny ID?",
            text: "This will deny the user's ID verification. The user will be prompted to resubmit.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Deny",
            confirmButtonColor: "#dc3741",
        });
        if (!confirm.isConfirmed) return;

        this.setState({ idActionLoading: true });
        try {
            const response = await UsersAPI.denyIDVerification(uuid);
            if (response?.success) {
                await sweetalert.fire({ icon: "success", text: "ID verification denied. The user will be prompted to resubmit." });
                this.props.onIDStatusChanged?.();
            } else {
                sweetalert.fire({ icon: "error", text: response?.reason || "Unable to deny ID verification." });
            }
        } finally {
            this.setState({ idActionLoading: false });
        }
    }

    getIDVerificationSection() {
        const user = this.props.selectedUser;
        if (!user || user.UUID === -1 || !this.hasSchoolUserPerm()) return null;

        const status = user.IDVerificationStatus;
        if (!status) return null;

        const statusColor = status === "Approved" ? "#28a745" : status === "Denied" ? "#dc3741" : "#f0ad4e";

        return (
            <div style={{ border: "1px solid #dee2e6", borderRadius: "5px", padding: "1rem 1.25rem", marginTop: "1rem", marginBottom: "1rem" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: status === "Pending" ? "1rem" : 0 }}>
                    <h6 style={{ margin: 0, fontWeight: 600 }}>ID Verification</h6>
                    <span style={{ color: statusColor, fontWeight: 600, fontSize: "0.95rem" }}>{status}</span>
                </div>

                {user.IDFrontPath && (
                    <>
                        <hr style={{ marginTop: "0.75rem", marginBottom: "1rem" }} />
                        {!this.state.idFrontUrl && !this.state.idImagesLoading && (
                            <div className="text-center">
                                <button className="btn btn-sm btn-outline-secondary" onClick={() => this.loadIDImages()}>
                                    View ID Image
                                </button>
                            </div>
                        )}
                        {this.state.idImagesLoading && (
                            <p className="text-center mb-0" style={{ color: "#888" }}>Loading image...</p>
                        )}
                        {this.state.idFrontUrl && (
                            <>
                                <div style={{ textAlign: "center", marginBottom: "1rem" }}>
                                    <a href={this.state.idFrontUrl} target="_blank" rel="noopener noreferrer" title="Click to open full size in new tab">
                                        <img src={this.state.idFrontUrl} alt="ID Front" style={{ maxWidth: "100%", maxHeight: "250px", objectFit: "contain", border: "1px solid #dee2e6", borderRadius: "4px", cursor: "pointer" }} />
                                    </a>
                                </div>
                                <p className="text-center mb-3" style={{ fontSize: "0.8rem", color: "#888" }}>Click image to open full size in a new tab</p>
                                {status === "Pending" && (
                                    <div className="text-center">
                                        <button className="btn btn-success" style={{ marginRight: "0.75rem", minWidth: "100px" }} disabled={this.state.idActionLoading} onClick={() => this.handleApproveID()}>
                                            {this.state.idActionLoading ? "Processing..." : "Approve"}
                                        </button>
                                        <button className="btn btn-danger" style={{ minWidth: "100px" }} disabled={this.state.idActionLoading} onClick={() => this.handleDenyID()}>
                                            {this.state.idActionLoading ? "Processing..." : "Deny"}
                                        </button>
                                    </div>
                                )}
                            </>
                        )}
                    </>
                )}
            </div>
        );
    }

    render() {
        // console.log('UserMgmt modal state', this.state)
        return  <div className="modal fade form_modal" id={UserManagementModal.ID} tabIndex={-1} role="dialog"
                    aria-labelledby="result_modal_label"
                    aria-hidden="true">
            <div className="modal-dialog modal-lg modal-xl" role="document">
                <div className="modal-content">
                    <div className="container-fluid">
                    <div className="modal-header">
                        <h5 className="modal-title" id="result_modal_label">User Management</h5>
                        <button style={{outline: 'none'}}  type="button" className="close" data-dismiss="modal"
                                aria-label="Close" onClick={()=>
                                    this.setState({
                                        selectedUser:{
                                            FirstName: "",
                                            LastName: "",
                                            Email: "",
                                            SelectedPerms: [],
                                            SelectedFacilities: [],
                                            Status: "Enabled",
                                            Disable: false,
                                            AuthFacilityGroup: {label: "", value: -1},
                                            UUID: -1,  // -1 means no user, create one
                                            PhoneNumber: null,
                                            FacilityIDs: null
                                        }
                                    })
                        }>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className={"row"}>
                            {this.getRoleDesc()}
                        </div>

                        { buildRow("First Name",
                            <input className="form-control"
                                id="FirstName"
                                maxLength={50}
                                autoComplete="off"
                                type={"search"}
                                name={"First Name"}
                                aria-label="First Name"
                                onChange={(e) => this.setState((prevState) => ({
                                    selectedUser: {
                                        ...prevState.selectedUser,
                                        FirstName: e.target.value
                                    }
                                })
                                )}
                                //    readOnly={this.state.selectedUser.UUID !== -1}
                                value={this.state.selectedUser.FirstName}
                            />
                        )}

                        {buildRow("Last Name",
                            <input className="form-control"
                                id="LastName"
                                maxLength={50}
                                autoComplete="off"
                                type={"search"}
                                name={"Last Name"}
                                aria-label="Last Name"
                                onChange={(e) => this.setState((prevState) => ({
                                    selectedUser: {
                                        ...prevState.selectedUser,
                                        LastName: e.target.value
                                    }
                                })
                                )}
                                // readOnly={this.state.selectedUser.UUID !== -1}
                                value={this.state.selectedUser.LastName}
                            />
                        )}

                        {buildRow("Phone Number",
                            <PhoneInput
                                id={'Phone Number'}
                                placeholder="Enter phone number (10 digit)"
                                value={this.state.selectedUser.PhoneNumber}
                                aria-label="Phone Number"
                                onChange={(e) => this.setState((prevState)=>({
                                    selectedUser:{ ...prevState.selectedUser, PhoneNumber: e ? e : null}
                                }))}
                                defaultCountry="US"
                            />
                        )}

                        {buildRow("Email/Username",
                            <input className="form-control"
                                id="Email/Username"
                                maxLength={100}
                                autoComplete="off"
                                type={"search"}
                                name={"Email"}
                                placeholder="name@example.com"
                                aria-label="Email or Username"
                                onChange={(e) => this.setState((prevState) => ({
                                    selectedUser: {
                                        ...prevState.selectedUser,
                                        Email: e.target.value
                                    }
                                })
                                )}
                                readOnly={this.state.selectedUser.UUID !== -1}
                                value={this.state.selectedUser.Email}
                            />
                        )}

                        { buildRow("Permission Groups",
                            <Select
                                placeholder={<div className="accessibilityText">Please Select...</div>}
                                value={this.state.selectedUser.SelectedPerms}
                                name={"Permissions"}
                                aria-label={getReactSelectAriaLabelMultiselect("Permission Groups", this.state.selectedUser.SelectedPerms)}
                                onChange={(e) => {
                                    const wasSchoolUser = this.hasSchoolUserPerm();
                                    const willBeSchoolUser = e?.some(p => p.value === 17);
                                    this.setState((prevState) => ({
                                        selectedUser: {
                                            ...prevState.selectedUser,
                                            SelectedPerms: e,
                                            SelectedFacilities: wasSchoolUser !== willBeSchoolUser ? [] : prevState.selectedUser.SelectedFacilities
                                        },
                                        selectedSchoolDistrict: wasSchoolUser !== willBeSchoolUser ? undefined : prevState.selectedSchoolDistrict
                                    }));
                                }}
                                className={"state_select"}
                                options={this.state.permGroups}
                                isMulti={true}
                            />
                        )}

                        {/* { buildRow("Facility Group",
                            <Select
                                placeholder={<div className="accessibilityText">Please Select...</div>}
                                value={this.state.selectedUser.AuthFacilityGroup}
                                name={"Facility Group"}
                                aria-label={getReactSelectAriaLabel("Facility Group", this.state.selectedUser.AuthFacilityGroup)}
                                onChange={(e) => this.setState((prevState)=>({
                                    selectedUser: {
                                        ...prevState.selectedUser,
                                        AuthFacilityGroup: e
                                    }})
                                )}
                                options={this.state.facilityGroups}
                                className={"state_select"}
                                isMulti={false}
                                readOnly={this.state.selectedUser.UUID !== -1 && !this.hasSchoolUserPerm()}
                                isDisabled={this.state.selectedUser.UUID !== -1 && !this.hasSchoolUserPerm()}
                            />
                        )} */}

                        { this.hasSchoolUserPerm() && buildRow("School District",
                            <Select
                                placeholder={<div className="accessibilityText">Please Select...</div>}
                                value={this.getEffectiveSchoolDistrict()}
                                name={"School District"}
                                aria-label={getReactSelectAriaLabel("School District", this.getEffectiveSchoolDistrict())}
                                onChange={(e) => this.setState({ selectedSchoolDistrict: e || null })}
                                options={this.state.districts}
                                className={"state_select"}
                                isClearable={true}
                            />
                        )}

                        { buildRow(this.hasSchoolUserPerm() ? "Schools" : "Facilities",
                            <Select
                                placeholder={<div className="accessibilityText">Please Select...</div>}
                                value={this.state.selectedUser.SelectedFacilities}
                                name={"Facilities"}
                                aria-label={getReactSelectAriaLabelMultiselect(this.hasSchoolUserPerm() ? "Schools" : "Facilities", this.state.selectedUser.SelectedFacilities)}
                                onChange={(e) => this.setState((prevState)=>({
                                    selectedUser: {
                                        ...prevState.selectedUser,
                                        SelectedFacilities: e
                                    }})
                                )}
                                options={this.getSchoolOrFacilityOptions()}
                                className={"state_select"}
                                isMulti={true}
                                readOnly={this.state.selectedUser.UUID !== -1 && !this.hasSchoolUserPerm()}
                                isDisabled={this.state.selectedUser.UUID !== -1 && !this.hasSchoolUserPerm()}
                            />
                        )}

                        { this.getUserAccountStatusInput() }

                        { this.state.selectedUser.UUID !== -1 && this.hasSchoolUserPerm() &&
                            buildRow("User Agreement",
                                <input className="form-control"
                                    id="DataAgreementAccepted"
                                    type={"search"}
                                    readOnly={true}
                                    value={this.props.selectedUser.DataAgreementAccepted ? "Accepted" : "Not Accepted"}
                                />
                            )
                        }

                        { this.getIDVerificationSection() }
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary"
                                    onClick={()=>{
                                        //form validations
                                        if(isBlank(this.state.selectedUser.FirstName) ||
                                            isOnlyWhitespace(this.state.selectedUser.FirstName)){
                                            return sweetalert.fire({icon: 'error', title: '', text: 'First Name is required.'})
                                        }
                                        if(isBlank(this.state.selectedUser.LastName) ||
                                            isOnlyWhitespace(this.state.selectedUser.LastName)){
                                            return sweetalert.fire({icon: 'error', title: '', text: 'Last Name is required.'})
                                        }
                                        if(isBlank(this.state.selectedUser.Email) ||
                                            isOnlyWhitespace(this.state.selectedUser.Email)){
                                            return sweetalert.fire({icon: 'error', title: '', text: 'Email is required.'})
                                        }
                                        if(!isValidEmail(this.state.selectedUser.Email)){
                                            return sweetalert.fire({icon: 'error', title: '', text: 'Email format is invalid.'})
                                        }
                                        if(!this.state.selectedUser.SelectedPerms ||
                                            this.state.selectedUser.SelectedPerms.length === 0){
                                            return sweetalert.fire({icon: 'error', title: '', text: 'At least one Permission Group is required.'})
                                        }
                                        if(!this.state.selectedUser.SelectedFacilities ||
                                            this.state.selectedUser.SelectedFacilities.length === 0){
                                            return sweetalert.fire({icon: 'error', title: '', text: 'At least one Facility is required.'})
                                        }
                                        // if(this.state.selectedUser.AuthFacilityGroup.value === -1){
                                        //     return sweetalert.fire({icon: 'error', title: '', text: 'Facility Group is required. Select "null" to leave Facility Group unassigned'})
                                        // }
                                        this.props.onSubmit(this.state.selectedUser)
                                    }}
                            >
                                Submit
                            </button>
                        </div>
                    
                </div>
                </div>

            </div>
        </div>;
    }
}